goog.provide("shadow.js.shim.module$$mui$material$Collapse");
goog.provide("module$shadow_js_shim_module$$mui$material$Collapse");
shadow.js.shim.module$$mui$material$Collapse = shadow.js.nativeProvides["@mui/material/Collapse"] = shadow$bridge("@mui/material/Collapse");
module$shadow_js_shim_module$$mui$material$Collapse.default = shadow.js.shim.module$$mui$material$Collapse;
